import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { Button } from 'merchant-portal-components';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Box, Checkbox } from '@material-ui/core';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { FlatButton } from 'merchant-portal-components';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const offerTypes = [
  { label: 'Select Product(s)', value: 'products' },
  { label: 'Select Combo(s)', value: 'combos' },
];

export function ApplyOfferTo({
  selectedOffers,
  onOfferChange,
  notShowAllMenu,
  currentSource,
}) {
  const localOfferTypes = useMemo(() => {
    return notShowAllMenu
      ? offerTypes.filter((offer) => offer.value !== 'all_menu')
      : offerTypes;
  }, [notShowAllMenu]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const checked = useCallback(
    (value) => {
      switch (value) {
        case 'products':
          return selectedOffers?.[currentSource]?.includes('products');
        case 'combos':
          return selectedOffers?.[currentSource]?.includes('combos');
        default:
          return false;
      }
    },
    [selectedOffers]
  );

  const handleOfferChange = (value, checked) => {
    if (value === 'all_menu') {
      onOfferChange(
        {
          ...selectedOffers,
          [currentSource]: ['products', 'combos'],
        },
        value
      );
      handleClose();
      return;
    }
    if (selectedOffers?.[currentSource]?.includes(value)) {
      const newSelectedOffers = selectedOffers[currentSource].filter(
        (item) => item !== value
      );
      onOfferChange(
        {
          ...selectedOffers,
          [currentSource]: newSelectedOffers,
        },
        value
      );
    } else {
      onOfferChange(
        {
          ...selectedOffers,
          [currentSource]: [...(selectedOffers[currentSource] || []), value],
        },
        value
      );
    }
  };

  return (
    <Box width='100%'>
      <Box
        onClick={handleClick}
        fullWidth
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          cursor: 'pointer',
          border: '1px solid #ccc',
          padding: '10px 15px',
          borderRadius: '4px',
        }}
      >
        <Typography>Apply Offer To</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </Box>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // align left
        transformOrigin={{ vertical: 'top', horizontal: 'left' }} // align left
        PaperProps={{
          style: {
            width: anchorEl ? anchorEl.clientWidth : 'auto',
            maxWidth: '100%',
            padding: 10,
          },
        }}
      >
        <Box width='100%'>
          {!notShowAllMenu && (
            <Button onClick={() => handleOfferChange('all_menu', true)}>
              Select Entire Menu
            </Button>
          )}
          {offerTypes.map((offer) => (
            <Box
              key={offer.value}
              sx={{
                width: '100% !important',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Checkbox
                color='primary'
                checked={checked(offer.value)}
                onChange={(e) =>
                  handleOfferChange(offer.value, e.target.checked)
                }
                inputProps={{ 'aria-label': offer.label }}
              />
              <Typography>{offer.label}</Typography>
            </Box>
          ))}
        </Box>
      </Popover>
    </Box>
  );
}
